export class GblMenuobject {
  ObjectId: number;
  ObjectCode: string;
  ObjectName: string;
  ObjectDescription: string;
  MenuId?: number;
  ObjectType: string;
  DisplaySerial: number;
  DisplayIcon: string;
  IsDefault: boolean;
  IsActive?: boolean;
  OrgId?: number;
  CreatedBy?: number;
  CreatedOn?: Date;
  LastModifiedBy?: number;
  LastModifiedOn?: Date;

  IsSelect?: boolean;
}
